import { useContext } from "react";
import { twMerge } from "@/helpers/twMerge";
import { getCompanyPhoneNumber } from "@/selectors";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";

import BasePhoneLink from "../../../../components/BaseComponents/BasePhoneLink";
import { CompanyContext } from "../../../../components/CompanyList/CompanyContext";
import { PhoneIcon } from "../../../assets/icons/PhoneIcon";

export const PhoneLink = ({ className }) => {
	const { company } = useContext(CompanyContext);
	const phoneNumber = useSelector((state) =>
		getCompanyPhoneNumber(state, { company }),
	);

	return (
		<BasePhoneLink
			company={company}
			className={twMerge(
				`tw:relative tw:mb-4 tw:flex tw:h-[48px] tw:w-[175px] tw:items-center tw:justify-center tw:rounded-[3px] tw:bg-[#44a4ed] tw:py-3 tw:hover:bg-[#449adb] tw:lg:flex tw:lg:w-full tw:lg:py-0`,
				className,
			)}
		>
			<div className="tw:flex tw:items-center tw:justify-center tw:rounded-full">
				<PhoneIcon className="tw:h-6 tw:w-6" />
			</div>
			<div className="tw:flex-col tw:lg:flex">
				<div className="tw:ml-2 tw:pt-1 tw:text-base tw:font-bold tw:text-white">
					{phoneNumber}
				</div>
			</div>
		</BasePhoneLink>
	);
};

PhoneLink.propTypes = {
	className: PropTypes.string,
};
